import React, { useState, useCallback, useRef } from "react";
import { Input } from "reactstrap";

import { Button } from "components/Button";
import { MAX_CUSTOM_PRODUCT_INPUT_LENGTH } from "variables";

export const EditableTitle = ({ field, isDisabled }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const prevValueRef = useRef(field.value);
  const handleToggleEditMode = useCallback(() => {
    const currentValue = field.value?.trim();
    if (!currentValue) {
      field.onChange({
        target: {
          name: field.name,
          value: prevValueRef.current,
        },
      });
    } else {
      prevValueRef.current = currentValue;
    }
    setIsEditMode((val) => !val);
  }, [field]);

  return (
    <div className="d-flex gap-2 align-items-center">
      {isEditMode && !isDisabled ? (
        <Input
          {...field}
          type="text"
          name="title"
          bsSize="sm"
          className="h5 mb-0"
          onBlur={handleToggleEditMode}
          maxLength={MAX_CUSTOM_PRODUCT_INPUT_LENGTH}
        />
      ) : (
        <span onClick={handleToggleEditMode} className="h5 mb-0">
          {field.value}
        </span>
      )}
      <Button
        color="tertiary"
        type="button"
        iconPrefix="trox"
        icon="pencil-light"
        iconClassName="icon-16"
        classNames="p-0 cursor-pointer mb-1 border-0"
        onClick={handleToggleEditMode}
        disabled={isDisabled}
      />
    </div>
  );
};
